export const property = {
  createProperty: {
    title: "إنشاء عقار",
    of: "من",
  },
  sections: {
    details: "تفاصيل العقار",
    presentation: "العرض التقديمي",
    rooms: "الغرف",
    bookingSettings: "إعدادات الحجز",
    checkinSettings: "إعدادات تسجيل الوصول",
    extras: "خدمات إضافية",
  },

  menu: {
    name: "الاسم",
    location: "الموقع",
    logo: "شعار العقار",
    capacity: "السعة",
    services: "خدمات العقار",
    description: "الوصف",

    roomTypes: "أنواع الغرف",
    roomManagement: "إدارة الغرف",

    imagesRooms: "صور الغرف",
    imagesProperty: "صور العقار",

    priceCurrency: "السعر والعملة",
    rates: "الأسعار",
    maintenance: "صيانة العقار",

    scheduling: "الجدولة",

    sesHospedajes: "SES للإقامات",

    smartLocks: "الأقفال الذكية",
    experiences: "التجارب والخدمات",
    chatbot: "روبوت المحادثة بالذكاء الاصطناعي",
  },

  firstStep: {
    heading: "ما اسم مكان إقامتك؟",
    subheading:
      "اجذب النزلاء باسم جذّاب يبرز أفضل ما في مكانك.",
    fieldLabel: "اسم مكان إقامتك",
    placeholder: "مثال: شاطئ الفردوس",
    internalNameLabel: "الاسم الداخلي",
    internalNamePlaceholder: "اسم مرجعي داخلي لمكان الإقامة",
  },

  locationStep: {
    heading: "أين يقع مكان إقامتك؟",
    subheading:
      "أدخِل العنوان الدقيق حتى يتمكّن النزلاء من العثور على مكانك بسهولة.",
    countryLabel: "الدولة",
    addressLabel: "العنوان الكامل",
    addressPlaceholder: "مثال: شارع سيربيس 25، إشبيلية",
    cityLabel: "المدينة",
    cityPlaceholder: "مثال: إشبيلية",
    zipLabel: "الرمز البريدي",
    zipPlaceholder: "مثال: 41004",
  },
  logoStep: {
    heading: "ما هو شعار مكان إقامتك؟",
    description:
      "أضِف شعار مكان إقامتك ليبدو أكثر احترافية وأسهل في التمييز. الصيغ المسموح بها: PNG وJPG وSVG.",
    currentLogoTitle: "الشعار الحالي:",
    currentLogoAlt: "الشعار الحالي",
  },

  roomTypeStep: {
    heading: "معلومات الغرفة",
    description:
      "أدخِل اسمًا لهذا النوع من الغرف، مثل «غرفة مزدوجة» أو «جناح عائلي». سيساعدك ذلك على تمييزها بسهولة في التقويم وقنوات الحجز. ويمكنك من لوحة التحكم إضافة أنواع الغرف الأخرى.",
    basicInfoTitle: "المعلومات الأساسية",
    nameLabel: "الاسم",
    namePlaceholder: "اسم مخصّص",
    occupancyTitle: "سعة الغرفة",
    adultsLabel: "البالغون",
    childrenLabel: "الأطفال",
    infantsLabel: "الرُّضّع",
  },

  hotelRoomsStep: {
    heading: "خصّص الغرف الفعلية لعقارك",
    description:
      "أنشئ الغرف الفعلية التي ستكون متاحة للحجوزات، مثل «101 - غرفة مزدوجة» أو «302 - جناح عائلي». سيساعدك ذلك على تنظيمها في التقويم وإدارة الإتاحة بسهولة.",
    roomTypeLabel: "نوع الغرفة",
    roomNameLabel: "اسم الغرفة",
    roomNamePlaceholder: "اسم مخصّص",
    roomCodeLabel: "رقم الغرفة أو رمزها",
    roomCodePlaceholder: "اختياري",
  },

  capacityStep: {
    heading: "شارِك التفاصيل الأساسية عن مكانك",
    description:
      "حدِّد عدد النزلاء وغرف النوم والحمّامات. لاحظ أن غرف النوم والحمّامات تُعدّ خاصة افتراضيًا. إذا كانت مشتركة، يمكنك تحديث ذلك لاحقًا في تفاصيل عقارك.",
    labels: {
      guests: "النزلاء",
      bedrooms: "غرف النوم",
      bathrooms: "الحمّامات",
    },
  },

  servicesStep: {
    heading: "أظهِر للنزلاء ما يقدّمه مكانك",
    subtitle:
      "اختر وسائل الراحة المتاحة. يمكنك إضافة المزيد لاحقًا من نظام إدارة المحتوى.",
    services: {
      oven: "فرن وموقد",
      pets_allowed: "يُسمح بالحيوانات الأليفة",
      wifi: "إنترنت واي فاي",
      essentials: "المستلزمات الأساسية",
      washing_machine: "غسالة ملابس",
      air_conditioning: "تكييف الهواء",
      heating: "تدفئة مركزية",
      parking: "موقف سيارات",
      children_allowed: "يُسمح بالأطفال",
      refrigerator: "ثلاجة",
    },
  },

  priceStep: {
    heading: "ما سعر الليلة؟",
    subtitle:
      "حدِّد السعر الافتراضي لإنشاء أول سعر ليلي، بالإضافة إلى عملة عقارك.",
    labels: {
      pricePerNight: "سعر الليلة",
      currency: "العملة",
    },
    placeholders: {
      priceExample: "مثال: 100",
    },
    requiredAsterisk: "*",
  },

  descriptionStep: {
    heading: "كيف تصف مكانك؟",
    subtitle:
      "اجذب النزلاء بوصف موجز لعقارك. أبرِز وسائل الراحة المتاحة والمعالم القريبة.",
    placeholders: {
      example:
        "مثال: شقة علوية أنيقة بإطلالة على المدينة — مثالية للعمل والتسوّق والاستمتاع بأجواء المدينة.",
    },
    inspiration: "هل تحتاج إلى إلهام؟",
    buttons: {
      useAI: "استخدم الذكاء الاصطناعي",
      generating: "جارٍ الإنشاء...",
    },
    errors: {
      generate:
        "حدث خطأ أثناء إنشاء الوصف. يُرجى المحاولة مرة أخرى.",
    },
  },
  navigation: {
    save: "حفظ",
    next: "التالي",
  },
  common: {
    success: "تم بنجاح",
    error: "خطأ",
    cancel: "إلغاء",
    save: "حفظ",
  },

  images: {
    heading: "صور العقار",
    subtitleHotel:
      "أضِف صور غرفك لاستخدامها في صفحة الحجز المباشر على موقعك.",
    subtitleApt:
      "أضِف صور عقارك لاستخدامها في صفحة الحجز المباشر على موقعك.",

    loadRoomsError: "تعذّر تحميل الغرف",
    uploadSuccess: "تم رفع الصور الصالحة بنجاح",
    uploadErrorGeneric: "خطأ في رفع الصور",

    deleteConfirmMessage: "هل أنت متأكد أنك تريد حذف هذه الصورة؟",
    deleteConfirmHeader: "تأكيد",
    deleteAccept: "حذف",
    deleteReject: "إلغاء",
    deleteSuccess: "تم حذف الصورة بنجاح",
    deleteError: "خطأ في حذف الصورة",

    setMainSuccess: "تم تحديث الصورة الرئيسية",
    setMainError: "خطأ في تعيين الصورة الرئيسية",

    invalidFilesTitle: "ملفات غير صالحة",

    mainBadge: "رئيسية",
  },

  dropzone: {
    prompt: "اسحب الصور إلى هنا أو انقر للاختيار",
    formatHint: "الصيغ: JPEG وPNG وGIF.",
    uploading: "جارٍ رفع الصور... {progress}%",
    invalidHeader: "بعض الملفات لا تستوفي المتطلبات:",
    reasonType: "نوع غير صالح",
    reasonSize: "يتجاوز حدّ الحجم",
    and: "و",
  },

  checkin: {
    heading: "متى سيتم إرسال روابط تسجيل الوصول؟",
    subtitle:
      "جدوِل الإرسال التلقائي لرابط تسجيل الوصول إلى نزلائك.",

    options: {
      same_day: { amount: "نفس اليوم", text: "لتسجيل الوصول" },
      24: { amount: "24 ساعة", text: "قبل تسجيل الوصول" },
      48: { amount: "48 ساعة", text: "قبل تسجيل الوصول" },
      72: { amount: "72 ساعة", text: "قبل تسجيل الوصول" },
      disabled: { amount: "تعطيل", text: "سأرسله يدويًا" },
    },
    recommended: "موصى به",

    details: {
      sameDay: "6 صباحًا نفس اليوم",
      previousNight: "6 مساءً الليلة السابقة",
      corresponding: "6 مساءً المقابلة",
    },

    confirm: {
      message: "هل أنت متأكد أنك تريد تغيير موعد تسجيل الوصول؟",
      header: "تأكيد التغيير",
      accept: "تغيير الموعد",
      reject: "إلغاء",
    },

    toasts: {
      loadError: {
        title: "خطأ",
        body: "فشل تحميل إعدادات تسجيل الوصول.",
      },
      saveSuccess: {
        title: "تم تحديث الإعدادات",
        body: "اكتملت العملية بنجاح",
      },
    },

    messages: {
      disabled: "الإرسال التلقائي معطّل. يجب إرساله يدويًا.",
      same_day: "سيتم إرسال روابط تسجيل الوصول في الساعة 6 صباحًا في نفس يوم تسجيل الوصول",
      exactly24: "سيتم إرسال روابط تسجيل الوصول في الساعة 6 مساءً في الليلة السابقة لتسجيل الوصول",
      // If you don't have ICU plural, use a generic message
      daysBefore:
        "سيتم إرسال روابط تسجيل الوصول في الساعة 6 مساءً، قبل {days} يوم من تسجيل الوصول",
    },
  },

  police: {
    header: "تسجيل بيانات السلطة المختصة",
    toasts: {
      saveSuccess: {
        title: "اكتمل الإجراء بنجاح",
        body: "تم حفظ بيانات السلطة بنجاح",
      },
    },
    errors: {
      lessorRequired: {
        title: "خطأ، حقل المؤجِّر",
        body: "رمز المؤجِّر إلزامي",
      },
      establishmentRequired: {
        title: "خطأ، حقل المنشأة",
        body: "رمز المنشأة إلزامي",
      },
    },
  },

  identity: {
    title: "متجر تسجيل الوصول",
    subtitle: "عند تسجيل الوصول يصل الضيف رابط عبر واتساب بما يمكنه إضافته إلى إقامته.",
    propertyLabel: "العقار:",
    toggle: {
      title: "تفعيل التحقق من الهوية",
      hint: "عند التفعيل، سيُطلب من النزلاء التحقق من هويتهم.",
      on: "تشغيل",
      off: "إيقاف",
    },
    config: {
      whatTitle: "ماذا تطلب من الضيف؟",
      whatHint:
        "اختر الصور التي سيتعين عليه التقاطها. صورة واحدة على الأقل.",
      frontTitle: "الوجه الأمامي للوثيقة",
      frontDesc:
        "الوجه الذي يحمل الصورة. وهو الذي تتم مقارنته بالصورة الذاتية.",
      backTitle: "الوجه الخلفي للوثيقة",
      backDesc: "الظهر، حيث يوجد عادةً العنوان ومنطقة القراءة الآلية.",
      selfieTitle: "صورة ذاتية فورية",
      selfieDesc: "صورة لوجهه تُلتقط في الحال بالكاميرا.",
      compareOn: "تتم مقارنة الوجه الموجود في الوثيقة بالصورة الذاتية.",
      compareOff:
        "تُحفظ الصورة فقط: بدون الوثيقة والصورة الذاتية لا توجد وجوه للمقارنة.",
      requiredTitle: "وإذا لم يتطابق الوجهان…",
      noTitle: "يمكنه المتابعة",
      noDesc:
        "يُكمل تسجيل الوصول على أي حال وتراه مُعلَّماً في اللوحة.",
      yesTitle: "لا يمكنه المتابعة",
      yesDesc:
        "لن يتمكن من إنهاء تسجيل الوصول حتى تنجح العملية. يمكنه المحاولة عدة مرات.",
      lockedHint: "لاشتراط ذلك يلزم الوجه الأمامي للوثيقة والصورة الذاتية.",
      summaryTitle: "سيرى الضيف",
      needOne: "يجب أن تطلب صورة واحدة على الأقل.",
      noStorage:
        "في هذا البلد لا نحتفظ بصور الهوية، بل بالنتيجة فقط. وبدون المقارنة بالوجه لن يبقى أي سجل.",
      serviceDown:
        "إذا تعطّلت خدمة المقارنة لدينا، يُسمح للضيف بالمتابعة وتراه مُعلَّماً: لا أحد يبقى عند الباب بسبب عطل من جانبنا.",
    },
    toasts: {
      updated: "تم تحديث إعدادات التحقق من الهوية بنجاح",
      updateError: "خطأ في تحديث إعدادات التحقق من الهوية",
    },
  },

  guestReviews: {
    subtitle:
      "أدخِل رابط موقع التقييم الذي تريد إعداده حتى يتمكّن نزلاؤك من ترك ملاحظاتهم، سواء على Google أو أي موقع تقييم آخر تستخدمه. يساعد ذلك على تحسين ظهور مكان الإقامة وسمعته.",
    enableTitle: "تفعيل تقييمات النزلاء",
  },

  smartLocks: {
    title: "الأقفال الذكية",
    subtitle:
      "اتصل بالأقفال الذكية المتوافقة وانسَ المفاتيح التقليدية. أنشئ رموز الدخول وأرسِلها تلقائيًا — دون عمل يدوي، وبأمان 100%.",
    propertyLabel: "العقار",
    compatibleTitle: "الأقفال الذكية المتوافقة",
    andManyMore: "والمزيد...",

    enableTitle: "تفعيل القفل الذكي",
    enableHelp:
      "أرسِل رمز الدخول إلى نزلائك بمجرد اكتمال تسجيل الوصول، في موعد تسجيل الوصول المحدّد تمامًا.",

    configTitle: "الإعدادات",
    configSubtitle: "حدِّد تفضيلات إرسال رمز الدخول",

    deliveryLabel: "وقت إرسال رمز الدخول",
    deliveryDesc:
      "اختر الوقت الذي سيُرسَل فيه رمز الدخول إلى نزيلك في يوم حجزه.",
    saveTimeBtn: "حفظ الوقت",
    saveTimeLoading: "جارٍ الحفظ...",

    accessTypeLabel: "نوع رمز الدخول",

    static: {
      title: "رمز ثابت",
      desc: "استخدم الرمز نفسه لجميع النزلاء",
    },
    dynamic: {
      title: "رمز ديناميكي",
      desc: "أنشئ رموزًا فريدة لكل حجز",
      soon: "قريبًا",
    },

    masterCodeLabel: "رمز الدخول الرئيسي",
    masterCodePlaceholder: "أدخِل رمز الدخول الرئيسي",
    saveCodeBtn: "حفظ الرمز",
    saveCodeLoading: "جارٍ الحفظ...",

    masterCodeHelp:
      "سيُرسَل هذا الرمز تلقائيًا إلى النزلاء في الوقت المحدّد في يوم تسجيل وصولهم.",

    dynamicInfo: {
      title: "رموز دخول ديناميكية",
      desc: "ستنشئ هذه الميزة المتميّزة رموز دخول فريدة لكل حجز تلقائيًا، ما يوفّر أمانًا أقوى وتجربة أفضل للنزلاء. متاحة قريبًا!",
    },

    support: {
      title: "هل تحتاج إلى مساعدة في التكامل؟",
      desc: "نتكامل مع جميع العلامات التجارية الكبرى للأقفال الذكية. سيساعدك فريقنا التقني في إعداد طرازك المحدّد.",
      cta: "تواصل مع الدعم",
    },

    errors: {
      emptyKey: "يُرجى إدخال مفتاح دخول",
    },

    toasts: {
      updateSuccess: "تم تحديث إعدادات القفل الذكي بنجاح",
      updateError: "خطأ في تحديث إعدادات القفل الذكي",
      timeSuccess: "تم تحديث وقت الإرسال بنجاح",
      timeError: "خطأ في تحديث وقت الإرسال",
      keySuccess: "تم حفظ مفتاح الدخول بنجاح",
      keyError: "خطأ في حفظ مفتاح الدخول",
    },
  },

  services: {
    listMovedHelp: "قائمة الخدمات واحدة للحساب كله: تُكتب مرة وتُحدَّد في أي إعلانات تُقدَّم.",
    listMovedLink: "انتقل إلى الخدمات والتجارب",
    title: "التجارب والخدمات",
    subtitle: "أدِر الخدمات الإضافية لعقارك.",
    enableTitle: "تفعيل متجر التجارب والخدمات",
    enableHelp:
      "روّج لجميع التجارب والخدمات الإضافية لعقارك. يتلقّى النزلاء رابطًا عبر WhatsApp عند تسجيل الوصول.",
    storeType: {
      title: "نوع المتجر",
      internal: {
        title: "متجر داخلي",
        desc: "أدِر خدماتك مباشرةً على المنصّة",
      },
      external: {
        title: "متجر خارجي",
        desc: "أعِد توجيه النزلاء إلى متجرك الخارجي",
      },
    },
    externalConfig: {
      title: "إعداد المتجر الخارجي",
      guestMessageLabel: "رسالة للنزلاء",
      guestMessagePlaceholder:
        "مثال: اكتشف خدماتنا الإضافية وتجاربنا الفريدة في متجرنا الإلكتروني...",
      guestMessageHelp:
        "الرسالة التي تظهر للنزلاء بعد تسجيل الوصول (200 حرف كحد أقصى)",
      urlLabel: "رابط متجرك الخارجي",
      urlPlaceholder: "https://your-external-store.com",
      urlHelp: "الرابط الكامل حيث يمكن للنزلاء حجز التجارب والخدمات",
      noteTitle: "ملاحظة:",
      noteText:
        "سيتلقّى النزلاء هذه الرسالة المخصّصة مع الرابط بعد إتمام تسجيل الوصول.",
    },
    addBtn: "إضافة",
    delete: {
      title: "حذف الخدمة؟",
      text: "لا يمكن التراجع عن هذا الإجراء",
      confirm: "حذف",
      cancel: "إلغاء",
    },
    toasts: {
      stateUpdated: "تم تحديث حالة الخدمة",
      deleted: "تم حذف الخدمة بنجاح",
      storeUpdated: "تم تحديث إعدادات التجارب والخدمات بنجاح",
      storeError: "خطأ في تحديث إعدادات التجارب والخدمات",
      configUpdated: "تم تحديث إعداد المتجر بنجاح",
      configError: "خطأ في تحديث إعداد المتجر",
    },
  },
  bot: {
    enableTitle: "تفعيل المساعد الافتراضي",
    enableHelp: "أتمِت دعم النزلاء بردود سريعة عبر WhatsApp.",
  },

  rooms: {
    heading: "أنواع الغرف",
    subtitle: "أدِر أنواع غرف عقارك.",
    addTypeCta: "إضافة نوع غرفة",
    adultsCapacity: "سعة البالغين: {count}",
    emptyList: "لا توجد غرف مسجّلة.",

    deleteConfirmHeader: "تأكيد الحذف",
    deleteConfirmMessage:
      "هل أنت متأكد أنك تريد حذف هذه الغرفة؟ لا يمكن التراجع عن هذا الإجراء.",
    deleteConfirmAccept: "نعم، احذف",
    deleteConfirmReject: "إلغاء",

    deleteSuccess: "تم حذف الغرفة بنجاح.",
    deleteError: "خطأ في حذف الغرفة.",
  },

  roomMgmt: {
    remaining: "المتاح: {count}",
    heading: "إدارة الغرف",
    subtitle: "خصّص غرفًا فردية للأنواع المسجّلة.",
    totalRooms: "إجمالي الغرف: {count}",

    typeLabel: "النوع",
    codeLabel: "الرمز",
    nameLabel: "الاسم",
    descLabel: "الوصف",

    selectPlaceholder: "اختر",
    codePlaceholder: "الرمز",
    namePlaceholder: "اسم الغرفة",
    descPlaceholder: "وصف الغرفة",

    addBtn: "إضافة",

    planLimitTitle: "تم بلوغ الحد",
    planLimitMsg:
      "لقد بلغت الحد الأقصى لعدد الغرف المسموح به في خطتك. يُرجى ترقية اشتراكك لإضافة المزيد.",

    loadTypesError: "تعذّر تحميل أنواع الغرف",
    loadRoomsError: "تعذّر تحميل الغرف الحالية",

    saveSuccessTitle: "تم بنجاح",
    saveSuccessMsg: "تم حفظ الغرف بنجاح",
    saveError: "تعذّر حفظ الغرف",

    deleteSuccess: "تم حذف الغرفة بنجاح.",
    deleteError: "خطأ في حذف الغرفة.",
    formIncompleteError:
      "يُرجى إكمال نوع الغرفة واسمها لجميع الغرف.",
  },

  rates: {
    heading: "الأسعار",
    subtitleHotel: "أدِر أسعار أماكن إقامتك.",
    subtitleSingle: "أدِر أسعار مكان إقامتك.",
    adultsCapacity: "سعة البالغين: {count}",
    roomsCount: "الغرف {count}",
    singleUnit: "وحدة الإقامة",

    table: {
      name: "الاسم",
      occupancy: "النزلاء",
      priceTaxIncl: "السعر (شامل الضريبة)",
      actions: "الإجراءات",
    },

    addRate: "إضافة سعر",
    emptyList: "لا توجد أسعار مسجّلة.",

    deleteConfirmHeader: "تأكيد الحذف",
    deleteConfirmMessage:
      "هل أنت متأكد أنك تريد حذف هذا السعر؟ لا يمكن التراجع عن هذا الإجراء.",
    deleteConfirmAccept: "نعم، احذف",
    deleteConfirmReject: "إلغاء",

    deleteSuccess: "تم حذف السعر بنجاح.",
    deleteError: "خطأ في حذف السعر.",
  },
};

export default property;
